<template>
  <div id="report-detail">
    <ipub-model width="1000px"
                :showHeader="true"
                :title="`Reviser ${info.__index}: ${info.firstName} ${info.lastName}`"
                style="min-width:450px;overflow:hidden"
                :visable="isVisable"
                :showFooter="false"
                @cancel="cancel">
      <!--                 height="600px" -->
      <div>
        <div class="flex title-tab mar-b-20">
          <div v-for="(item,index) in info.reviewerDecisionList"
               :key="index"
               @click="changeReport(item)"
               :class="['ipub-p1','title-tab-item',item.sign==activeKey ? 'title-tab-item-active':'']">
            Report{{item.sign}}</div>
        </div>
        <div class="ipub-p1 mar-b-20">
          <div class="mar-b-12">
            <span style="width:100px">Recommendation</span>
            <span class="mar-l-20 ipub-p2">{{termListStatus[activeData.decisionStatus]}}</span>
          </div>
          <div>
            <span style="width:100px">Decision Time</span>
            <span class="mar-l-20 ipub-p2">{{$moment(activeData.completedTime).format('DD / MM / YYYY')}}</span>
          </div>
        </div>
        <div v-if="activeData">
          <div class="mar-b-20">
            <div class="ipub-p1 mar-b-12 ipub-cursor-pointer packUp-gray"
                 @click="togalEditor(activeData,'showQuestion')">
              Custom Review Questions
              <ipub-icon :class="['ipub-p5 mar-l-40 rotate',activeData.showQuestion?'':'rotate-180']"
                         type="iconArrow" />
            </div>
            <div class="question-answer"
                 v-if="!activeData.showQuestion">
              <ul class="question-answer-list">
                <li class="question-answer-item"
                    :key="'question'+indexque"
                    v-for="(itemque,indexque) in activeData.questionList">
                  <div class="common question">
                    <span class="ipub-p4 fw-bd color tag">Q: </span>
                    <span class="ipub-p4 fw-bd color">{{itemque.questionContent}}</span>
                  </div>
                  <div class="common answer">
                    <span class="ipub-p4 fw-bd color tag">A: </span>
                    <span class="ipub-p4 fw-bd color">{{itemque.answer || (itemque.type ==='SINGLE' ? JSON.parse(itemque.questionOption)[itemque.checkedOption].answer : itemque.checkedOption)}}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="mar-b-20"
               v-if="activeData.authorNotes">
            <div class="ipub-p1 fw-bd mar-b-12 ipub-cursor-pointer packUp-gray"
                 @click="togalEditor(activeData,'showAuthor')">
              Comments to Author
              <ipub-icon :class="['ipub-p5 mar-l-40 rotate',activeData.showAuthor?'':'rotate-180']"
                         type="iconArrow" />
            </div>
            <div v-if="!activeData.showAuthor">
              <div class="ipub-p2"
                   v-if="activeData.authorNotes"
                   v-html="activeData.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
              <template v-else>
                <div class="line-color">No notes or comments.</div>
              </template>

            </div>

          </div>
          <div class="mar-b-20"
               v-if="activeData.editorNotes">
            <div class="ipub-p1 fw-bd mar-b-12 ipub-cursor-pointer packUp-gray"
                 @click="togalEditor(activeData,'showEditor')">
              Comments to Editor
              <ipub-icon :class="['ipub-p5 mar-l-40 rotate',activeData.showEditor?'':'rotate-180']"
                         type="iconArrow" />
            </div>
            <div v-if="!activeData.showEditor">
              <div class="ipub-p2"
                   v-if="activeData.editorNotes"
                   v-html="activeData.editorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>

            </div>

          </div>

          <div class="mar-b-20"
               v-show="activeData.reviewerFileList && activeData.reviewerFileList.length>0">
            <div class="ipub-p1 mar-b-16 ipub-cursor-pointer packUp-gray"
                 @click="togalEditor(activeData,'showAttachment')">Attachment of Reviewer
              <ipub-icon :class="['ipub-p5 mar-l-40 rotate',activeData.showAttachment?'':'rotate-180']"
                         type="iconArrow" />
            </div>

            <div class="file-contain"
                 style="display:flex;flex-wrap:wrap;"
                 v-if="!activeData.showAttachment">
              <!-- <ipub-label size="small"
                          style="align-items: center;height:30px;margin-right:12px;margin-bottom: 12px;border-color:#E9EEF0"
                          type="link"
                          v-for="(itemfile,indexfile) in activeData.reviewerFileList"
                          :key="itemfile.id"
                          @click="download(itemfile,indexfile)">
                {{itemfile.name}}
              </ipub-label> -->
              <div class="file-contain">
                <ul class="flex file-list">
                  <li class="file-item mar-b-10"
                      style="margin-right:10px;cursor:pointer"
                      @click="download(itemfile,indexfile)"
                      v-for="(itemfile,indexfile) in activeData.reviewerFileList"
                      :key="itemfile.id">
                    <span class="ipub-p4 fw-bd color tag ipub-cursor-pointer">{{itemfile.name}} </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div>
            <a :name="'toReport'">
              <div class="ipub-p1 mar-b-12 packUp-gray ipub-cursor-pointer"
                   @click="togalEditor(activeData,'showAuthorReplay')"
                   v-if="activeData.authorReply || (activeData.authorReplyFileList && activeData.authorReplyFileList.length>0)">
                Author’s Response
                <ipub-icon :class="['ipub-p5 mar-l-40 rotate',activeData.showAuthorReplay?'':'rotate-180']"
                           type="iconArrow" />
              </div>
              <div v-if="!activeData.showAuthorReplay">
                <div v-show="activeData.authorReply">
                  <div class="ipub-p1 fw-bd mar-b-12">
                    Author’s Note
                  </div>
                  <div class="ipub-p2"
                       v-html="activeData.authorReply?activeData.authorReply.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' '):'- -'"></div>
                </div>
                <div style="margin-top:20px"
                     v-show="activeData.authorReplyFileList && activeData.authorReplyFileList.length>0">
                  <div class="ipub-p1 fw-bd">
                    Author’s Response File
                  </div>
                  <div class="file-contain"
                       style="margin-top:10px">
                    <ul class="flex file-list">
                      <li class="file-item mar-b-10"
                          style="margin-right:10px;cursor:pointer"
                          @click="download(itemauth,indexauth)"
                          :key="itemauth.id"
                          v-for="(itemauth,indexauth) in activeData.authorReplyFileList">
                        <span class="ipub-p4 fw-bd color tag ipub-cursor-pointer">{{itemauth.name}} </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>

    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DECISION_STATUS } from '@/utils/dict'
import help from '@/utils/help'
import zip from '@/utils/zip'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      termListStatus: DECISION_STATUS,
      activeKey: '',
      activeData: {},

    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain'
    })
  },
  watch: {
    isVisable (newV) {
      if (newV) {
        this.activeData = this.info && this.info.reviewerDecisionList[this.info.__indexrep]
        this.activeKey = this.activeData.sign
      }
    }
  },
  mounted () {
  },
  methods: {
    changeReport (item) {
      this.activeKey = item.sign
      this.activeData = item
    },
    download (item) {
      const file = item
      if (file) {
        const url = file.path
          ? this.domain + '/' + file.path
          : window.URL.createObjectURL(file.file)
        help.download(url, file.name)
      } else {
        zip.zipFile(item, 'author_files.zip')
      }
    },

    // comments to Editor Author
    togalEditor (item, type) {
      item[type] == undefined ? (item[type] = true) : (item[type] = !item[type])
      this.activeData = JSON.parse(JSON.stringify(this.activeData))
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
@import './main.scss';

.title-tab {
  border-bottom: 1px solid #e9eef0;
  cursor: pointer;
  &-item {
    padding: 6px 0;
    margin-right: 80px;
    position: relative;
    transition: 0.3s all;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -3px;
      height: 2px;
      background: $link_color;
      width: 0;
      transition: 0.3s all;
    }
    &-active,
    &:hover {
      color: $link_color;
      &::after {
        color: $link_color;
        width: 52px;
      }
    }
  }
}
</style>